module.exports = __webpack_public_path__ + "static/media/body_bg.f7225803.png";